export default __webpack_public_path__ + "static/media/lastofusep5002.20af6d25.jpg";